/**
 * レイアウトに関する定数
 */

// サイドバーの幅
export const NAV_WIDTH = 256;

// 提案メッセージエリアの高さ（余白含む）
export const PROPOSAL_MESSAGE_AREA_HEIGHT = 270;
